<template>
<div>
  <div class="page-header">
    <div class="add-item d-flex">
      <div class="page-title">
        <h4>{{ $t('new_customer') }}</h4>
      </div>
    </div>
    <ul class="table-top-head">
      <li>
        <div class="page-btn">
          <router-link to="/customers/list" class="btn btn-added">
            <span>Back</span>
          </router-link>
        </div>
      </li>
      <li>
        <a data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" id="collapse-header"><i class="ti ti-chevron-up"></i></a>
      </li>
    </ul>
  </div>

  <form @submit.prevent="submitCustomer" enctype="multipart/form-data">
    <div class="card">
      <div class="card-body add-product pb-0">
        <div class="accordion-card-one accordion" id="accordionExample">
          <div class="accordion-item">
            <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <div class="row">
                  <!-- Customer Name -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{$t('customer_name')}} <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      v-model="customer.customer_name"
                      class="form-control"
                      :placeholder="$t('enter_customer_name')"
                    />
                    <div v-if="errors.customer_name" class="text-danger mt-1">{{ errors.customer_name }}</div>
                  </div>

                  <!-- Phone -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{$t('customer_phone')}} <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      v-model="customer.customer_phone"
                      class="form-control"
                      :placeholder="$t('enter_phone_number')"
                    />
                    <div v-if="errors.customer_phone" class="text-danger mt-1">{{ errors.customer_phone }}</div>
                  </div>

                  <!-- Customer Code -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("customer_code") }} </label>
                    <input
                      type="number"
                      v-model.number="customer.customer_code"
                      class="form-control"
                      :placeholder="$t('enter_customer_code')"
                    />
                    <div v-if="errors.customer_code" class="text-danger mt-1">{{ errors.customer_code }}</div>
                  </div>

                  <!-- Due Limit -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("due_limit") }}</label>
                    <input
                      type="number"
                      step="0.01"
                      v-model.number="customer.due_limit"
                      class="form-control"
                      :placeholder="$t('enter_due_limit')"
                    />
                    <div v-if="errors.due_limit" class="text-danger mt-1">{{ errors.due_limit }}</div>
                  </div>

                  <!-- Due Limit Days -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("due_limit_days") }}</label>
                    <input
                      type="number"
                      v-model.number="customer.due_limit_days"
                      class="form-control"
                      :placeholder="$t('enter_due_limit_days')"
                    />
                    <div v-if="errors.due_limit_days" class="text-danger mt-1">{{ errors.due_limit_days }}</div>
                  </div>

                  <!-- Customer Address -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("customer_address") }}</label>
                    <input
                      type="text"
                      v-model="customer.customer_address"
                      class="form-control"
                      :placeholder="$t('enter_customer_address')"
                    />
                    <div v-if="errors.customer_address" class="text-danger mt-1">{{ errors.customer_address }}</div>
                  </div>

                  <!-- Customer Bank -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("customer_bank") }}</label>
                    <input
                      type="text"
                      v-model="customer.customer_bank"
                      class="form-control"
                      :placeholder="$t('enter_customer_bank')"
                    />
                    <div v-if="errors.customer_bank" class="text-danger mt-1">{{ errors.customer_bank }}</div>
                  </div>

                  <!-- Contact Person -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("customer_contact_person") }}</label>
                    <input
                      type="text"
                      v-model="customer.customer_contact_person"
                      class="form-control"
                      :placeholder="$t('enter_contact_person')"
                    />
                    <div v-if="errors.customer_contact_person" class="text-danger mt-1">{{ errors.customer_contact_person }}</div>
                  </div>

                  <!-- Email -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("customer_email") }} </label>
                    <input
                      type="email"
                      v-model="customer.customer_email"
                      class="form-control"
                      :placeholder="$t('enter_email')"
                    />
                    <div v-if="errors.customer_email" class="text-danger mt-1">{{ errors.customer_email }}</div>
                  </div>

                  <!-- Status -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("status") }} </label>
                    <select v-model="customer.status" class="form-select">
                      <option value="enabled">Enabled</option>
                      <option value="disabled">Disabled</option>
                    </select>
                    <div v-if="errors.status" class="text-danger mt-1">{{ errors.status }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-12 text-end">
      <div class="btn-addproduct mb-4">
        <button type="button" class="btn btn-cancel me-2" @click="cancelForm">{{ $t('cancel') }}</button>
        <button type="submit" class="btn btn-submit" @click="onSubmit">{{ $t('submit') }}</button>
      </div>
    </div>
  </form>
</div>
</template>


<script>
import apiUrls from "@/urls";
import Vue3Datepicker from 'vue3-datepicker';
import {useToast} from "vue-toastification";

export default {
  components: {
    Vue3Datepicker,
  },

  emits: ['select'],

  data() {
    return {
      customer: {
      customer_name: '', customer_code: null, due_limit: null, due_limit_days: null, customer_address: '',
      customer_bank: '', customer_contact_person: '', customer_email: '', customer_phone: '', status: 'enabled',
    },
      errors: {},
      errorMessage: "",
    };
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  methods: {
      async submitCustomer() {
        // Frontend validation before making API call
          this.errors = {};
          if (!this.customer.customer_name.trim()) this.errors.customer_name = this.$t('error.required');
          if (!this.customer.customer_phone.trim()) this.errors.customer_phone = this.$t('error.required');

          if (Object.keys(this.errors).length > 0) {
            return;
          }

        try {
          const response = await this.$axios.post(apiUrls.customers.post, this.customer );

          this.toast.success('Customer successfully created!')

          // Redirect only after successful response
          this.$router.push('/customers/list');

          // Emit event to update parent component
          this.$emit("create_success");

          this.resetForm();
        } catch (error) {
          this.applyCustomerErrors(error);
        }
      },

      applyCustomerErrors(error) {
        const data = error.response?.data || {};
        if (data.error) this.errorMessage = data.error;
        if (data.errors) {
          this.errors = data.errors;
          return;
        }
        if (data.customer_phone) {
          const message = data.customer_phone;
          this.errors.customer_phone = Array.isArray(message) ? message[0] : message;
        }
      },

      cancelForm() {
        this.$router.push('/customers/list');
      },

      resetForm() {
        // Reset form fields and errors
        this.customer = {
          customer_name: '', customer_code: null, due_limit: null, due_limit_days: null, customer_address: '',
          customer_bank: '', customer_contact_person: '', customer_email: '', customer_phone: '', status: 'enabled',
        };
        this.errors = {};
        this.errorMessage = "";
      }
    },

};
</script>
